import { createAction, createReducer } from 'deox';

export interface ConsumerSearch {
  result: 'success' | 'error' | 'existingAccount' | null;
}

export interface ConsumerSearchState {
  entity: ConsumerSearch;
}

export const defaultState: ConsumerSearchState = {
  entity: { result: null },
};

export const mergeConsumerSearch = createAction(
  'MERGE_CONSUMER_SEARCH',
  resolve => (data: Partial<ConsumerSearch>) => resolve(data),
);

export const consumerSearchReducer = createReducer(
  defaultState,
  handleAction => [
    handleAction(mergeConsumerSearch, (state, { payload: data }) => {
      return {
        ...state,
        entity: {
          ...state.entity,
          ...data,
        },
      };
    }),
  ],
);

export interface MountedState {
  consumerSearch: ReturnType<typeof consumerSearchReducer>;
}

export const selectConsumerSearch = (state: MountedState): ConsumerSearch =>
  state.consumerSearch.entity;

export default consumerSearchReducer;
